export const TKeyAgentProspectSearch = {
  AGENT_PROSPECT_NO_ORDERS: "AGENT_PROSPECT_NO_ORDERS",
  AGENT_PROSPECT_PROCESS: "AGENT_PROSPECT_PROCESS",
  AGENT_PROSPECT_TASK_POTENTIALS: "AGENT_PROSPECT_TASK_POTENTIALS",
  AGENT_PROSPECT_TASK_SOURCE: "AGENT_PROSPECT_TASK_SOURCE",
  AGENT_PROSPECT_BACK: "AGENT_PROSPECT_BACK",
  AGENT_PROSPECT_CRITERIA_TITLE: "AGENT_PROSPECT_CRITERIA_TITLE",
  AGENT_PROSPECT_PLATFORMS: "AGENT_PROSPECT_PLATFORMS",
  AGENT_PROSPECT_QUERIES: "AGENT_PROSPECT_QUERIES",
  AGENT_PROSPECT_IDENTITY_TITLE: "AGENT_PROSPECT_IDENTITY_TITLE",
  AGENT_PROSPECT_MATCH_TITLE: "AGENT_PROSPECT_MATCH_TITLE",
  AGENT_PROSPECT_AVOID_TITLE: "AGENT_PROSPECT_AVOID_TITLE",
  AGENT_PROSPECT_ADD_TITLE: "AGENT_PROSPECT_ADD_TITLE",
  AGENT_POTENTIAL_PROSPECTS_TITLE: "AGENT_POTENTIAL_PROSPECTS_TITLE",
  AGENT_POTENTIAL_PROSPECTS_DESC: "AGENT_POTENTIAL_PROSPECTS_DESC",
  AGENT_PROSPECT_LIST_TITLE: "AGENT_PROSPECT_LIST_TITLE",
  AGENT_PROSPECT_NO_PROSPECTS: "AGENT_PROSPECT_NO_PROSPECTS",
  AGENT_PROSPECT_FIT_SCORE: "AGENT_PROSPECT_FIT_SCORE",
  AGENT_PROSPECT_MIN_SCORE: "AGENT_PROSPECT_MIN_SCORE",
  AGENT_PROSPECT_SAVE: "AGENT_PROSPECT_SAVE",
  AGENT_PROSPECT_DUPLICATE: "AGENT_PROSPECT_DUPLICATE",
  AGENT_PROSPECT_UPDATE_EXISTING: "AGENT_PROSPECT_UPDATE_EXISTING",
  AGENT_PROSPECT_CONFIRM_TITLE: "AGENT_PROSPECT_CONFIRM_TITLE",
  AGENT_PROSPECT_CONFIRM_TEXT: "AGENT_PROSPECT_CONFIRM_TEXT",
  AGENT_PROSPECT_CONFIRM_BTN: "AGENT_PROSPECT_CONFIRM_BTN",
  AGENT_PROSPECT_FIELD_FULLNAME: "AGENT_PROSPECT_FIELD_FULLNAME",
  AGENT_PROSPECT_FIELD_ROLE: "AGENT_PROSPECT_FIELD_ROLE",
  AGENT_PROSPECT_FIELD_PITCH: "AGENT_PROSPECT_FIELD_PITCH",
  AGENT_PROSPECT_FIELD_COMPANY: "AGENT_PROSPECT_FIELD_COMPANY",
  AGENT_PROSPECT_FIELD_COMPANY_TYPE: "AGENT_PROSPECT_FIELD_COMPANY_TYPE",
  AGENT_PROSPECT_FIELD_COMPANY_SIZE: "AGENT_PROSPECT_FIELD_COMPANY_SIZE",
  AGENT_PROSPECT_FIELD_INDUSTRY: "AGENT_PROSPECT_FIELD_INDUSTRY",
  AGENT_PROSPECT_FIELD_LOCATION: "AGENT_PROSPECT_FIELD_LOCATION",
  AGENT_PROSPECT_FIELD_EMAIL: "AGENT_PROSPECT_FIELD_EMAIL",
  AGENT_PROSPECT_FIELD_PHONE: "AGENT_PROSPECT_FIELD_PHONE",
  AGENT_PROSPECT_FIELD_LINKS: "AGENT_PROSPECT_FIELD_LINKS",
  AGENT_PROSPECT_ADD_LINK: "AGENT_PROSPECT_ADD_LINK",
  AGENT_PROSPECT_FIELD_PROFILE_URL: "AGENT_PROSPECT_FIELD_PROFILE_URL",
  AGENT_PROSPECT_FIELD_SOURCE: "AGENT_PROSPECT_FIELD_SOURCE",
  AGENT_PROSPECT_PH_FULLNAME: "AGENT_PROSPECT_PH_FULLNAME",
  AGENT_PROSPECT_PH_ROLE: "AGENT_PROSPECT_PH_ROLE",
  AGENT_PROSPECT_PH_PITCH: "AGENT_PROSPECT_PH_PITCH",
  AGENT_PROSPECT_PH_COMPANY: "AGENT_PROSPECT_PH_COMPANY",
  AGENT_PROSPECT_PH_COMPANY_TYPE: "AGENT_PROSPECT_PH_COMPANY_TYPE",
  AGENT_PROSPECT_PH_COMPANY_SIZE: "AGENT_PROSPECT_PH_COMPANY_SIZE",
  AGENT_PROSPECT_PH_INDUSTRY: "AGENT_PROSPECT_PH_INDUSTRY",
  AGENT_PROSPECT_PH_LOCATION: "AGENT_PROSPECT_PH_LOCATION",
  AGENT_PROSPECT_PH_EMAIL: "AGENT_PROSPECT_PH_EMAIL",
  AGENT_PROSPECT_PH_PHONE: "AGENT_PROSPECT_PH_PHONE",
  AGENT_PROSPECT_PH_LINKS: "AGENT_PROSPECT_PH_LINKS",
  AGENT_PROSPECT_PH_PROOF: "AGENT_PROSPECT_PH_PROOF",
  AGENT_PROSPECT_PROOF_REQUIRED: "AGENT_PROSPECT_PROOF_REQUIRED",
  AGENT_PROSPECT_PH_PROFILE_URL: "AGENT_PROSPECT_PH_PROFILE_URL",
  AGENT_PROSPECT_PH_SOURCE: "AGENT_PROSPECT_PH_SOURCE",
  AGENT_PROSPECT_VIEW_PROFILE: "AGENT_PROSPECT_VIEW_PROFILE",
  AGENT_PROSPECT_DETAIL_SIGNALS: "AGENT_PROSPECT_DETAIL_SIGNALS",
  AGENT_PROSPECT_DETAIL_TAB_ABOUT: "AGENT_PROSPECT_DETAIL_TAB_ABOUT",
  AGENT_PROSPECT_DETAIL_TAB_FIT: "AGENT_PROSPECT_DETAIL_TAB_FIT",
  AGENT_PROSPECT_DETAIL_WHY_NOT: "AGENT_PROSPECT_DETAIL_WHY_NOT",
  AGENT_PROSPECT_ORDERS_TO_PROCESS: "AGENT_PROSPECT_ORDERS_TO_PROCESS",
  AGENT_PROSPECT_TAB_TODO: "AGENT_PROSPECT_TAB_TODO",
  AGENT_PROSPECT_TAB_DONE: "AGENT_PROSPECT_TAB_DONE",
  AGENT_PROSPECT_TAB_POTENTIAL: "AGENT_PROSPECT_TAB_POTENTIAL",
  AGENT_PROSPECT_NO_DONE: "AGENT_PROSPECT_NO_DONE",
  AGENT_PROSPECT_NO_POTENTIAL: "AGENT_PROSPECT_NO_POTENTIAL",
  AGENT_PROSPECT_VIEW: "AGENT_PROSPECT_VIEW",
  AGENT_PROSPECT_CANCEL_REFUND: "AGENT_PROSPECT_CANCEL_REFUND",
  AGENT_PROSPECT_CANCEL_TITLE: "AGENT_PROSPECT_CANCEL_TITLE",
  AGENT_PROSPECT_CANCEL_TEXT: "AGENT_PROSPECT_CANCEL_TEXT",
  AGENT_PROSPECT_CANCEL_CONFIRM: "AGENT_PROSPECT_CANCEL_CONFIRM",
  AGENT_PROSPECT_FILTER_ALL: "AGENT_PROSPECT_FILTER_ALL",
  AGENT_PROSPECT_FILTER_TODO: "AGENT_PROSPECT_FILTER_TODO",
  AGENT_PROSPECT_FILTER_ALMOST_DONE: "AGENT_PROSPECT_FILTER_ALMOST_DONE",
} as const;
